import React from "react";
import ScaleLoader from "react-spinners/ScaleLoader";
import PropTypes from "prop-types";

const Button = ({
  label,
  onClick,
  isLoading,
  disabled,
  size = 200, // Increased default size to accommodate longer labels
}) => {
  // Determine if the button is an "End Call" button
  const isEndCall = label.toLowerCase() === "end call";

  // Define dynamic styles based on the button type
  const backgroundColor = isEndCall ? "#ff4d4d" : "#ffffff"; // Red for "End Call", white otherwise
  const textColor = isEndCall ? "#ffffff" : "#000000"; // White text on red, black otherwise
  const borderColor = isEndCall ? "#ff4d4d" : "#dddddd"; // Red border for "End Call"

  // Adjust opacity and cursor based on disabled or loading state
  const currentOpacity = disabled || isLoading ? 0.75 : 1;
  const currentCursor = disabled || isLoading ? "not-allowed" : "pointer";

  // Define the button's content based on the loading state
  const Contents = isLoading ? (
    <ScaleLoader
      color={textColor}
      height={10}
      width={2.5}
      margin={0.5}
      loading={isLoading} // Dynamically controlled
      size={size * 0.2} // Scale loader size based on button size
      css={{ display: "block", margin: "0 auto" }}
    />
  ) : (
    <span
      style={{
        margin: 0,
        padding: 0,
        fontSize: size * 0.15, // Proportionate font size
        textAlign: "center",
        whiteSpace: "nowrap", // Prevent text from wrapping
      }}
    >
      {label}
    </span>
  );

  return (
    <center>
    <button
      onClick={onClick}
      disabled={disabled || isLoading} // Optionally disable when loading
      aria-label={label} // Accessibility improvement
      style={{
        backgroundColor: backgroundColor,
        color: textColor,
        border: `2px solid ${borderColor}`,
        borderRadius: "50%", // Keeps the button circular
        width: `${size}px`, // Fixed width
        height: `${size}px`, // Fixed height
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: `${size * 0.15}px`, // Scale font size
        outline: "none",
        boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
        transition: "all 0.3s ease",
        opacity: currentOpacity,
        cursor: currentCursor,
        padding: "0", // Remove padding to maintain circular shape
        textAlign: "center", // Ensure text is centered
        whiteSpace: "nowrap", // Prevent text from wrapping
      }}
    >
      {Contents}
    </button>
    </center>
  );
};

// PropTypes for better type checking and documentation
Button.propTypes = {
  label: PropTypes.string.isRequired, // Button label (e.g., "End Call")
  onClick: PropTypes.func, // Click handler
  isLoading: PropTypes.bool, // Loading state
  disabled: PropTypes.bool, // Disabled state
  size: PropTypes.number, // Allows customization of size (default: 200)
};

export default Button;
